import { Breadcrumb, Col, Row, Tabs } from "antd";
import { useState } from "react";
import { StockList } from "./StockList";
import ResetButton from "../UI/ResetButton/resetbutton";
import { getWarehousesBy, getWarehousesInventories } from "../../api/stock";
import { useParams } from "react-router";
import { useMutation, useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { FilterInput } from "../UI/FilterApi/filterapi";
import { Search } from "../UI/Search/Search";

function Stock() {
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedWarehouseInventories, setPaginatedWarehouseInventories] =
    useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");
  const [t] = useTranslation("common");
  const [key, setKey] = useState("1");
  const { id } = useParams();
  const onChange = (key: string) => {
    setKey(key);
  };

  const [itemName, setItemName] = useState("");
  useQuery("warehouse", () => getWarehousesBy(id), {
    onSuccess: (itemName) => {
      setItemName(itemName);
    },
  });

  const resetFilters = () => {
    getWarehouseInventories({
      limit: page * 10 + 10,
      q: "",
      warehouseid: id,
    }).then((res) => {
      setPaginatedWarehouseInventories(res.data?.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getWarehouseInventories({
      limit: page * 10 + 10,
      q: search,
      isActive: filter,
      warehouseid: id,
    }).then((res: any) => {
      setPaginatedWarehouseInventories(res.data?.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getWarehouseInventories({
      limit: page * 10 + 10,
      q: "",
      isActive: isActive,
      warehouseid: id,
    }).then((res: any) => {
      setPaginatedWarehouseInventories(res.data?.data);
    });
  };

  const getWarehouseInventories = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
    warehouseid: string | number | undefined;
  }) => {
    // Make your API request here using the updated parameters
    return await WarehouseInventoriesMutation(params);
  };

  const {
    mutateAsync: WarehouseInventoriesMutation,
    isLoading: isWarehouseInventoriesLoading,
  } = useMutation("warehouses", getWarehousesInventories);

  const items = [
    {
      key: "1",
      label: `${t("stock")}`,
    },
  ];

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("inventory")}</>,
              },
              {
                title: (
                  <Link to="/warehouses"> {`${t("warehouse-list")}`}</Link>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">{`${t("stock")}`}</span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={20} className="editTitle">
          {itemName}
        </Col>

        <Col offset={1} span={22}>
          <Tabs
            className="ant-tab"
            defaultActiveKey="1"
            activeKey={key}
            items={items}
            onChange={onChange}
          />
        </Col>
        <Col offset={1} span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={14}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <ResetButton
            onClick={() => {
              resetFilters();
            }}
          />
        </Col>
        <Col offset={1} span={22}>
          <StockList
            paginatedWarehouseInventories={paginatedWarehouseInventories}
            isWarehouseInventoriesLoading={isWarehouseInventoriesLoading}
            WarehouseInventoriesMutation={WarehouseInventoriesMutation}
            setPaginatedWarehouseInventories={setPaginatedWarehouseInventories}
            page={page}
            setPage={setPage}
            filter={filter}
            search={search}
            id={id}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "6%" }}>
        <Col offset={1} span={6}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
      </Row>
    </>
  );
}

export default Stock;
